import logo from "../../../../assets/images/logo.svg";
import { Heading, Text } from "../../../../components/common/typography";

type AuthHeaderProps = {
  title?: string;
  subtitle?: string;
};

function AuthHeader({ title, subtitle }: AuthHeaderProps) {
  return (
    <div className="flex flex-col items-center w-full">
      <img src={logo} alt="PlaySlotsMobile" className="mb-4" />
      {title && (
        <Heading variant="h3" className="text-center">
          {title}
        </Heading>
      )}
      {subtitle && (
        <Text variant="body" tone="body" className="text-center mt-1">
          {subtitle}
        </Text>
      )}
    </div>
  );
}

export default AuthHeader;
